// Third-party connector icon images — copied from @adminhub/images for platform compatibility.
// These are referenced by connector-config files in src/ui/third-party-connector-form-builder/connector-configs/
// SVGs are resolved as URLs by atlaspack's asset pipeline at build time.
// In test environments, .svg files are mapped to empty strings via jest moduleNameMapper.

/* eslint-disable @typescript-eslint/no-require-imports */
export const adobeSignIcon: string = require('./adobe-sign-logo.svg');
export const ahaIcon: string = require('./aha-logo.svg');
export const airtableIcon: string = require('./airtable-logo.svg');
export const asanaIcon: string = require('./asana-logo.svg');
export const azureDevopsIcon: string = require('./azure-devops-logo.svg');
export const boxIcon: string = require('./box-logo.svg');
export const canvaIcon: string = require('./canva-logo.svg');
export const confluenceDcDefaultSpaceIcon: string = require('./confluence-dc-default-space-icon.svg');
export const confluenceDcIcon: string = require('./confluence-dc-logo.svg');
export const databricksIcon: string = require('./databricks-logo.svg');
export const datadogIcon: string = require('./datadog-logo.svg');
export const docusignIcon: string = require('./docusign-logo.svg');
export const dropboxIcon: string = require('./dropbox-logo.svg');
export const dynatraceIcon: string = require('./dynatrace-logo.svg');
export const githubIcon: string = require('./github-logo.svg');
export const gitlabIcon: string = require('./gitlab-logo.svg');
export const globeIcon: string = require('./globe-icon.svg');
export const globeIconBrand: string = require('./globe-icon-brand.svg');
export const gmailIcon: string = require('./gmail-logo.svg');
export const googleCalendarIcon: string = require('./google-calendar-logo.svg');
export const googleDriveIcon: string = require('./google-drive-logo.svg');
export const hrisIcon: string = require('./hris-logo.svg');
export const hubspotIcon: string = require('./hubspot-logo.svg');
export const jiraDcIcon: string = require('./jira-dc-logo.svg');
export const jiraDefaultProjectIcon: string = require('./jira-default-project-icon.svg');
export const lucidIcon: string = require('./lucid-logo.svg');
export const microsoftOutlookCalendarIcon: string = require('./outlook-calendar-logo.svg');
export const microsoftOutlookMailIcon: string = require('./outlook-mail-logo.svg');
export const microsoftSharepointIcon: string = require('./sharepoint-logo.svg');
export const microsoftTeamsIcon: string = require('./microsoft-teams-logo.svg');
export const miroIcon: string = require('./miro-logo.svg');
export const mondayIcon: string = require('./monday-logo.svg');
export const newrelicIcon: string = require('./newrelic-logo.svg');
export const notionIcon: string = require('./notion-logo.svg');
export const rocketImage: string = require('./rocket.svg');
export const salesforceIcon: string = require('./salesforce-logo.svg');
export const scheduleImage: string = require('./schedule.svg');
export const serviceNowIcon: string = require('./servicenow-logo.svg');
export const shieldFlameBrand: string = require('./shield-flame-brand.svg');
export const slackIcon: string = require('./slack-logo.svg');
export const smartsheetIcon: string = require('./smartsheet-logo.svg');
export const spinnakerIcon: string = require('./spinnaker-logo.svg');
export const workdayIcon: string = require('./workday-logo.svg');
export const zendeskIcon: string = require('./zendesk-logo.svg');
